import type { PixelLogger } from '@/logger';

/**
 * Prefixed logger scoped to Integration Engine — never mixes with Transport logs.
 */
export class DestinationLogger {
  private readonly logger: PixelLogger;

  private readonly scope: string;

  constructor(logger: PixelLogger, scope = 'Integration') {
    this.logger = logger;
    this.scope = scope;
  }

  forAdapter(name: string): DestinationLogger {
    return new DestinationLogger(this.logger, name);
  }

  debug(message: string, ...args: unknown[]): void {
    this.logger.debug(`[${this.scope}] ${message}`, ...args);
  }

  info(message: string, ...args: unknown[]): void {
    this.logger.info(`[${this.scope}] ${message}`, ...args);
  }

  warn(message: string, ...args: unknown[]): void {
    this.logger.warn(`[${this.scope}] ${message}`, ...args);
  }

  error(message: string, ...args: unknown[]): void {
    this.logger.error(`[${this.scope}] ${message}`, ...args);
  }
}
